module.exports = __webpack_public_path__ + "static/media/teka.45825cf6.png";